import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import ErrorBoundary from "./components/ErrorBoundary";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Events from "./pages/Events";
import EventDetails from "./pages/EventDetails";
import RsvpManage from "./pages/RsvpManage";
import RsvpVerify from "./pages/RsvpVerify";
import About from "./pages/About";
import HowItWorks from "./pages/HowItWorks";
import Safety from "./pages/Safety";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import NonAffiliation from "./pages/NonAffiliation";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminEventForm from "./pages/admin/AdminEventForm";
import AdminEventDetail from "./pages/admin/AdminEventDetail";
import AdminAudit from "./pages/admin/AdminAudit";
import NotFound from "./pages/NotFound";
import Offline from "./pages/Offline";
import ErrorPage from "./pages/ErrorPage";

export default function App() {
  return (
    <ErrorBoundary fallback={<ErrorPageWrapper />}>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:eventId" element={<EventDetails />} />
            <Route path="/rsvp/manage" element={<RsvpManage />} />
            <Route path="/rsvp/verify" element={<RsvpVerify />} />
            <Route path="/about" element={<About />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/safety" element={<Safety />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/non-affiliation" element={<NonAffiliation />} />
            <Route path="/offline" element={<Offline />} />
            <Route path="/error" element={<ErrorPage />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/events/new"
              element={
                <ProtectedRoute>
                  <AdminEventForm mode="create" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/events/:eventId/edit"
              element={
                <ProtectedRoute>
                  <AdminEventForm mode="edit" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/events/:eventId"
              element={
                <ProtectedRoute>
                  <AdminEventDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/audit"
              element={
                <ProtectedRoute>
                  <AdminAudit />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

function ErrorPageWrapper() {
  return (
    <Layout>
      <ErrorPage />
    </Layout>
  );
}
